import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import LocalFilePicker from "../associatedFiles/LocalFilePicker";
import AsyncLoadingButton from "../asyncLoadingButton/AsyncLoadingButton";
import type { FC } from "react";
import { useEffect, useState } from "react";

interface Props {
  readonly open: boolean;
  readonly title: string;
  readonly onClose: () => void;
  readonly onFileSelected: (file: File) => Promise<void>;
}

const FilePickerDialog: FC<Props> = ({ open, title, onClose, onFileSelected }) => {
  const [file, setFile] = useState<File | undefined>(undefined);

  useEffect(() => {
    setFile(undefined);
  }, [open]);
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <LocalFilePicker onFileChange={setFile} />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          Anuluj
        </Button>
        <AsyncLoadingButton
          color="primary"
          disabled={!file}
          onClick={() => (file ? onFileSelected(file) : Promise.resolve())}
        >
          Dodaj
        </AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default FilePickerDialog;
